export default "__VITE_ASSET__yjwSuuIA__"